import api from "src/apis/api"

// ── Members (memberships) ────────────────────────────────────────────────────
export async function fetchMembers({ page = 1, per_page = 20, q = "" } = {}) {
  const params = new URLSearchParams()
  params.set("page", page)
  params.set("per_page", per_page)
  if (q) params.set("q", q)

  const { data } = await api.get(`/api/v1/memberships?${params}`)
  return data
}

export async function updateMemberRole(id, roleSlug) {
  const { data } = await api.patch(`/api/v1/memberships/${id}`, { membership: { role: roleSlug } })
  return data
}

// ── Roles (for the role dropdown + the roles page) ───────────────────────────
export async function fetchRoles() {
  const { data } = await api.get("/api/v1/roles")
  return data
}

export async function fetchRole(id) {
  const { data } = await api.get(`/api/v1/roles/${id}`)
  return data
}

export async function updateRolePermissions(id, permissions) {
  const { data } = await api.patch(`/api/v1/roles/${id}`, { permissions })
  return data
}
